// removed by extract-text-webpack-plugin
module.exports = {"root":"radio-group--root--2mu4KQDr"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/radio-group/styles.css
// module id = ./components/forms/radio-group/styles.css
// module chunks = 0